<template>
  <div>
    <div class="product-add">
      <!--form表单-->
      <el-form size="small" label-width="150px" :model="form" ref="form">
        <div class="common-form">客服设置</div>
        <el-form-item label="客服电话1" :rules="[{ required: true, message: '请上传图片' }]" prop="phone">
          <el-input v-model="form.phone" placeholder="修改客服电话" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="客服电话2" :rules="[{ required: true, message: '请填写客服电话' }]" prop="mobile_two">
          <el-input v-model="form.mobile_two" placeholder="修改客服电话2" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="客服电话3" :rules="[{ required: true, message: '请填写客服电话' }]" prop="mobile_three">
          <el-input v-model="form.mobile_three" placeholder="修改客服电话" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="QQ" :rules="[{ required: true, message: '请填写qq' }]" prop="qq">
          <el-input v-model="form.qq" placeholder="填写qq" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="微信号" :rules="[{ required: true, message: '请填写微信号' }]" prop="wechat">
          <el-input v-model="form.wechat" placeholder="微信号" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="客服二维码" prop="service_image" :rules="[{ required: true, message: '请上传图片' }]">
          <el-row>
            <el-button type="primary" @click="openProductUpload('image', 'service_image')">选择图片</el-button>
            <div v-if="form.service_image!=''" class="img">
              <img :src="form.service_image" width="100" height="100" />
            </div>
          </el-row>
        </el-form-item>
        
      </el-form>
    </div>
    <div class="common-button-wrapper">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
    <!--上传图片组件-->
    <!-- <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload> -->
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>
<script>
import Technician from "@/api/technician.js";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload
  },
  data() {
    return {
      isProductUpload: false,
      isupload: false,
      // type:'',
      form: {
        qq: "",
        wechat: "",
        phone: "",
        mobile_two: "",
        mobile_three: "",
        mp_image: "",
        group_image: "",
        service_image: ""
      },
      filePath: "",
      config: {},
      file_name: "image"
    };
  },
  created() {
    this.getDate();
  },
  methods: {
    getDate() {
      Technician.mp_service2({}, true)
        .then(res => {
          console.log(res);
          this.form = res.data;
        })
        .catch(err => {});
    },
    /*打开上传图片*/
    openProductUpload: function(fileType, file_name) {
      this.file_name = file_name;
      if (fileType == "image") {
        this.config = {
          total: 1,
          fileType: "image"
        };
      } else {
        this.config = {
          total: 1,
          fileType: "video"
        };
      }
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        if (this.file_name == "video") {
          this.form.model.video_id = e[0].fileId;
          this.form.model.video = e[0];
        } else if (this.file_name == "service_image") {
          this.form.service_image = e[0].filePath;
        } else if (this.file_name == "group_image") {
          this.form.group_image = e[0].filePath;
        } else if (this.file_name == "mp_image") {
          this.form.mp_image = e[0].filePath;
        }
      }
      this.isProductUpload = false;
    },

    onSubmit() {
      let self = this;
      let params = self.form;
      Technician.mp_service(params, true)
        .then(res => {
          self.$message({
            message: res.msg,
            type: "success"
          });
        })
        .catch(err => {
          self.$message({
            message: err.msg,
            type: "warning"
          });
        });
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/setting/telephone/index.vue